import React, { Component, Fragment } from 'react';
import { Switch, Route } from 'react-router-dom';
import { withRouter } from 'react-router';
import { Header, Sidebar } from '../../component';
import { Mobile } from '../../routes';
import './Root.scss';
import CustomizedSnackbars from '../../component/snackbars/snackbars';

@withRouter
class Root extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSidebarOpened: false,
    };
  }

  toggleSidebar = () => this.setState({ isSidebarOpened: !this.state.isSidebarOpened });

  closeSidebar = () => this.setState({ isSidebarOpened: false })

  handleLogoutClick = () => this.props.authActions.logout()

  render() {
    return (
      <div className="root__mobile">
        <CustomizedSnackbars />
        <Header
          withoutSidebar
          user={this.props.user}
          onSidebarClick={this.toggleSidebar}
          onLogoutClick={this.handleLogoutClick}
          isSidebarOpened={this.state.isSidebarOpened}
        />
        <div onClick={this.state.isSidebarOpened ? this.closeSidebar : null} className={`content ${this.state.isSidebarOpened ? 'smooth' : ''}`}>
          <Switch>
            <Mobile />
          </Switch>
        </div>
      </div>
    );
  }
}

export default Root;
